import { useEffect, useState } from 'react';

function useGradualIncrement(target: number, duration = 1000) {
  const [displayPercentage, setDisplayPercentage] = useState(0);

  useEffect(() => {
    if (target < displayPercentage) {
      setDisplayPercentage(target);
      return;
    }

    const stepCount = 50;
    const increment = (target - displayPercentage) / stepCount;
    const intervalDuration = duration / stepCount;

    const interval = setInterval(() => {
      setDisplayPercentage((current) => {
        const nextValue = current + increment;
        if (nextValue >= target) {
          clearInterval(interval);
          return target;
        }
        return nextValue;
      });
    }, intervalDuration);

    return () => clearInterval(interval);
  }, [target, duration]);

  return Math.round(displayPercentage);
}

export default useGradualIncrement;
